export default __webpack_public_path__ + "static/media/img_azure-colorBkg.4fb33718.png";